import React from 'react'
import { Button, makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { secondaryButtonSVGbase64Url, secondaryButtonHoverSVGbase64Url } from '../../../utilities/Configurations'
const useStyles = makeStyles(theme => ({
    root: {
        backgroundImage: `url("${secondaryButtonSVGbase64Url}")`,
        padding: "0px",
        borderRadius: '0px',
        textTransform: 'none',
        backgroundRepeat: 'no-repeat',
        backgroundSize: "100% 100%",
        color: theme.palette.text.secondary,
        fontSize: '1rem',
        lineHeight: "1.25rem",
        fontWeight: "600",
        minWidth: "180px",
        [theme.breakpoints.down('xs')]: {
            minWidth: "100%",
        },
        '&:hover': {
            backgroundImage: `url("${secondaryButtonHoverSVGbase64Url}")`,
            backgroundColor: 'transparent'
        }
    },
    labelStyles: {
        padding: "15px",
        textAlign: 'center'
    }
}))

export default function SecondaryButton({ children, className, ...props }) {
    const classes = useStyles()
    return (
        <Button classes={{
            label: classes.labelStyles
        }} className={clsx(classes.root, className)} fullWidth={false}  {...props}>
            {children}
        </Button>
    )
}
